// One place for the facts about the site and the apps that appear in head
// tags, structured data, store links and llms.txt. CommonJS so gatsby-node.js
// can read it as well as the components.

const siteUrl = "https://schengensimple.com";

const site = {
  siteUrl,
  name: "Schengen Simple",
  publisher: "Roycroft Labs Ltd",
  locale: "en_GB",
  socialImageLandscape:
    "https://images.prismic.io/schengensimple/b5a0476e-2a44-4435-a366-6e9a57dfb709_social-media-thumbnail_LANDSCAPE.png?auto=compress,format",
  socialImageSquare:
    "https://images.prismic.io/schengensimple/688fe677-1730-454f-8d3e-87e70e9ac899_social-media-thumbnail_SQUARE.png?auto=compress,format",
  // Site ownership tokens for Google Search Console ("HTML tag" method, the
  // content value only) and Bing Webmaster Tools (the msvalidate.01 value).
  // Leave empty until there is one; the tag is only written when set.
  verification: {
    google: "",
    bing: "",
  },
};

const apps = {
  ios: {
    appId: "1637045933",
    // App Store Connect provider token, used by campaign links (pt=).
    providerToken: "122509372",
    listingUrl: "https://apps.apple.com/app/schengen-simple/id1637045933",
  },
  android: {
    packageName: "com.schengensimple.android",
    listingUrl:
      "https://play.google.com/store/apps/details?id=com.schengensimple.android",
  },
};

// The App Store rating shown on the homepage and repeated in structured data.
// Google only accepts aggregateRating when the same figures are visible on the
// page, so both read from here. Update the three values together.
// Source: UK App Store listing (itunes.apple.com/lookup?id=1637045933&country=gb).
const appStoreRating = {
  value: "4.8",
  count: 2533,
  displayCount: "2,500+",
  checkedOn: "2026-10-05",
};

// Campaign-tagged store links, so App Store Connect and Play Console can show
// which installs came from the website and from which kind of page.
const appStoreUrl = (campaign) =>
  `https://apps.apple.com/app/apple-store/id${apps.ios.appId}?pt=${
    apps.ios.providerToken
  }&ct=${encodeURIComponent(campaign)}&mt=8`;

// A tagged visit (see src/utils/inboundSource.js) passes its own source and
// medium through to Play Console; an untagged one is counted as the website.
const playStoreUrl = (campaign, inbound = null) =>
  `${apps.android.listingUrl}&referrer=${encodeURIComponent(
    `utm_source=${(inbound && inbound.source) || "website"}&utm_medium=${
      (inbound && inbound.medium) || "web"
    }&utm_campaign=${campaign}`
  )}`;

const absoluteUrl = (path = "/") => {
  const withLeading = path.startsWith("/") ? path : `/${path}`;
  const withTrailing = withLeading.endsWith("/")
    ? withLeading
    : `${withLeading}/`;
  return `${siteUrl}${withTrailing}`;
};

module.exports = {
  site,
  apps,
  appStoreRating,
  appStoreUrl,
  playStoreUrl,
  absoluteUrl,
};
